import { render, staticRenderFns } from "./PaymentExportItemExtract.vue?vue&type=template&id=13b18563&scoped=true"
import script from "./PaymentExportItemExtract.vue?vue&type=script&lang=js"
export * from "./PaymentExportItemExtract.vue?vue&type=script&lang=js"
import style0 from "./PaymentExportItemExtract.vue?vue&type=style&index=0&id=13b18563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b18563",
  null
  
)

export default component.exports